import React, { useState, useEffect } from 'react'
import {getSettings, updateSettings} from 'app/utils/dynamo.js'

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';

import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


export default function SettingsView(props){ 
    const _getSettings = async () => { 
      let val = await getSettings()
      console.log(val)
      return val
    } 

    const _updateSettings = async () => { 
      // console.log(configs)
      const result = await updateSettings(configs[0])
      console.log(result)
    }
    return(
        <div>
            <h1>Settings</h1>
            <button onClick={()=>_getSettings()} >Download</button>
            <button onClick={()=>_updateSettings()} >Update</button>

            { configs.map( conf => { 
              return( <FunctionList data={conf} />)
            })}
        </div>
    )
}

const FunctionList = ({data}) => { 
    const [toggleNew, setToggle] = useState(false)
    return ( 
        <Paper style={{padding: 10, margin: 10}}>
            <Button onClick={()=>console.log(data)}>Test</Button>
            <TextField
               label="Name" value={data.name}  variant="outlined"
               style={{padding:5}}
           />
            <TextField
               style={{padding:5}}
               label="ID" value={data.id}  variant="outlined" 
            />
             <TextField
               style={{padding:5}}
               label="Path" value={data.path}  variant="outlined" 
            />
          
          <h2>Logs Table Fields</h2>
          <EdiTable data={data} table={'tableConfig'}/>

          <h2>Run Tab Fields</h2>
          <EdiTable data={data} table={'logsConfig'}/>
        </Paper>
    )
}

// Editable Table Component
const EdiTable = ({data, table}) => { 
  const [toggleNew, setToggle] = useState(false)
  const [newData, setNewData] = useState({})

  const saveHandler = () => { 
    console.log(newData)
    console.log(data)
    let dataCopy = JSON.parse(JSON.stringify(data))
    dataCopy[table].push(newData)
    console.log(dataCopy)
  }

  const onChangeHandler = (e) => { 
    console.log(e.target.name)
    let updated = {...newData}
    updated[e.target.name] = e.target.value
    setNewData(updated)
  }
  
  return(
  <TableContainer component={Paper} style={{backgroundColor: '#efefef'}} >
  <Table  aria-label="simple table"  >
    <TableHead  >
      <TableRow >
        <TableCell >Title</TableCell>
        <TableCell >ID</TableCell>
        <TableCell >Type</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {data[table].map((row) => (
        <TableRow key={row.title}>
          <TableCell component="th" scope="row">{row.title}</TableCell>
          <TableCell >{row.id}</TableCell>
          <TableCell >{row.type?row.type:'Text'}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>

  <Collapse in={toggleNew}>
  <Table  aria-label="simple table">
    <TableRow key={'new'}>
        <TableCell component="th" scope="row">
          <TextField label="Title" variant="filled" name="title" value={newData.title || ''} onChange={onChangeHandler}/>
        </TableCell>
        <TableCell component="th" scope="row">
          <TextField label="ID" variant="filled" name="id" value={newData.id || ''} onChange={onChangeHandler}/>
        </TableCell>
        <TableCell component="th" scope="row">
          <TextField label="Type" variant="filled" name="type" value={newData.type || ''} onChange={onChangeHandler}/>
        </TableCell>
      </TableRow>
  </Table>
  </Collapse>
  <Table>
    <TableRow key={'test'}>
      <TableCell component="th" scope="row"></TableCell>
      <TableCell component="th" scope="row"></TableCell>
      <TableCell component="th" align="right" scope="row">
          { toggleNew && 
          <Button variant="outlined" style={{marginRight: 10}} color="primary" onClick={saveHandler}>Save</Button>
          }
          <Button variant="outlined" onClick={()=>setToggle(!toggleNew)} > 
           { toggleNew ? 'Cancel' : 'Add New'}
          </Button>
      </TableCell>
    </TableRow>
  </Table>
</TableContainer>
  )
}


let configs =[ { 
  id: 'geoguide',
  name: "City Geoguide", 
  path: 'geoguide',
  tableConfig : [ 
    { title: "Function", id: "function"}, 
    { title: "Date", id: "date"}, 
    { title: "Time", id: "time"}, 
    { title: "Run Type", id: "runType"},
    { title: "Status", id: "status", type: "badge"}, 
    { title: "Level_0", id: "params.id"}, 

  ], 
  logsConfig : [ 
    {id: 'id', required: true, default : 'chicago'}, 
  ], 
} , {
id: 'rake', 
name: 'Rake Weighter', 
path: 'rake',
tableConfig : [ 
  { title: "Function", id: "function"}, 
  { title: "Date", id: "date"}, 
  { title: "Time", id: "time"}, 
  { title: "Run Type", id: "runType"},
  { title: "Survey Count", id: "data.values.filter_df_size"},
  { title: "Status", id: "status", type: "badge"}, 
], 
logsConfig : [ 
  {id: 'level_0', required: true, default : 'chicago'}, 
  {id: 'date_from', required: true, default : '2020-10-01'}, 
  {id: 'date_to', required: true,  default : '2020-10-15'}, 
  {id: 'id', required: false}, 
], 
funcConfig : { 
  name: "Rake Weighter", 
  path: 'rake'
}
}
]